export class MockAuthProvider {
    async signIn() {
        return { uid: 'dev-user-001', isAnonymous: true };
    }
    async signOut() {
        // no-op in mock
    }
}
